export default __webpack_public_path__ + "images/0xd29f8a9e76ef42ba9f749583ed07cae7bfaec389.png";